module.exports = __webpack_public_path__ + "static/media/16UNODC12.0d5a8b82.jpg";